import { create } from 'zustand'

const useSlugStore = create((set) => ({
  slugs: {},
  addSlugs: (newSlugs) => set(({slugs}) => ({
    slugs: {
      ...slugs,
      ...newSlugs
    }
  })),
}))

const useSlugByUUID = uuid => useSlugStore(({slugs}) => slugs[uuid]);

const addSlugs = slugs => useSlugStore.getState().addSlugs(slugs);

export { useSlugByUUID, useSlugStore, addSlugs };
